import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, inject, Injectable } from '@angular/core';
import { Subscription, take, timer } from 'rxjs';
import { SnackbarComponent } from './snackbar.component';

@Injectable()
export class SnackbarService {

  overlay = inject(Overlay);
  private defaultDuration = 3000;
  public overlayRef: OverlayRef;
  public snackBarRef: ComponentRef<SnackbarComponent>;

  private waitTimerSub: Subscription;

  constructor() {

    // create cdk Overlay for Snackbar in order to work with cdk Dialogs
    // If the Snackbar would be placed inside app-root it could be blocked by dialog overlays and not show up
    this.overlayRef = this.overlay.create({
      panelClass: 'bottom-snackbar'
    });
    const userProfilePortal = new ComponentPortal(SnackbarComponent);
    this.snackBarRef = this.overlayRef.attach(userProfilePortal);
  }

  public showSnackBar(message: string, durationInMs = this.defaultDuration): void {
    this.snackBarRef.instance.message = message;
    if (this.waitTimerSub) {
      this.waitTimerSub.unsubscribe();
    }
    this.waitTimerSub = timer(durationInMs ? durationInMs : this.defaultDuration)
      .pipe(take(1))
      .subscribe(() => {
        this.snackBarRef.instance.message = null;
      });
  }
}
